import React, { Component, Fragment } from 'react';
import Input from '../FormInput/index';

export default class NumberOfVehiclePlaced extends Component {
   constructor(props) {
      super(props);
      const { placedNumberOfTrucks } = this.props;
      this.state = {
         numberOfVehiclePlaced : placedNumberOfTrucks ||'',
         previousNumberOfVehiclePlaced : placedNumberOfTrucks ||''
      };
      localStorage.setItem('isPriceUpdated', 'false');
   }

   onChange = (e) => {
      if (e.currentTarget.value <= 0) {
         if (e.currentTarget.value !== '' || e.currentTarget.value === 0) {
            return;
         }
      }

      if ((e.currentTarget.name === "numberOfVehiclePlaced" && e.currentTarget.value > 0)) {
         this.setState({ isPriceUpdated: true });
         localStorage.setItem('isPriceUpdated', 'true');
      }
      this.setState({
         [e.currentTarget.name]: e.currentTarget.value
      });

   }

   submit = () => {
      const { trip } = this.props;
      
      if ((this.state.numberOfVehiclePlaced === '' || Number(this.state.numberOfVehiclePlaced) === 0 || this.state.numberOfVehiclePlaced === null)) {
         alert("Please Enter Number of Vehicle");
         return;
      }
      let data={
         trip_id : trip.id,
         rfq_id :trip.rfqId,
         placed_number_of_trucks: Number(this.state.numberOfVehiclePlaced)
      }
      this.setState({ isPriceUpdated: false });
      localStorage.setItem('isPriceUpdated', 'false');
      this.props.saveVehiclePlaced(data);
   }

   componentWillReceiveProps(nextProps) {
      const priceUpdated = JSON.parse(localStorage.getItem('isPriceUpdated'));
      if(nextProps!== null && !priceUpdated){
      this.setState({
         numberOfVehiclePlaced: (nextProps.placedNumberOfTrucks>0) ? nextProps.placedNumberOfTrucks : '',
         previousNumberOfVehiclePlaced : (nextProps.placedNumberOfTrucks>0) ? nextProps.placedNumberOfTrucks : ''
      });
   }
   }

   render() {
      const { numberOfVehiclePlaced, previousNumberOfVehiclePlaced} = this.state;
      return (
         <div className="flex flex-column pr postBid-fields">
            <form onSubmit={this.submit} className="flex">
               <div className="wt-60">
                  <Input
                     type="number"
                     value={numberOfVehiclePlaced}
                     placeholder="Vehicle Placed"
                     name="numberOfVehiclePlaced"
                     onChange={this.onChange}
                     className="col-1 fs-14 no-border"
                     noTransition={true}
                     step="any"
                     containerClassName="no-transition-container"
                  />
               </div>
               {this.state.isPriceUpdated && Number(numberOfVehiclePlaced) > Number(previousNumberOfVehiclePlaced)  && <div className="fBold theme-color tCenter fs-14 pt-5 curP pr t-8 ml-10" onClick={this.submit}>
                     Submit
                        </div>}
            </form>
            <div className ="mt--30">
                       { Number(numberOfVehiclePlaced) < Number(previousNumberOfVehiclePlaced)  &&
                     <span className ="error-color">Vehicle Placement count can't be less than the previous one</span>
                     }
                       </div>
         </div>
      )
   }
}
